module.exports = __webpack_public_path__ + "static/img/HT-X8500.3f00b8c5.jpg";